<script>
	import en from "../strings.en"
	import fr from "../strings.fr"
	import Portal from "svelte-portal"
	import ProductFlags from "./ProductFlags.svelte";
	export let price='',availability='',lang='',ehf='',dotw='',uom='',onlineOnlyProduct='',dynAttr21='',isBuyable='',pricePerSqFt='', dynAttr295=''
	let strings = en;
	if(lang =='fr'){
		strings = fr;
	}
	let _strings = strings.strings

	let preferredStoreProvince = localStorage.getItem('preferredStore') ? JSON.parse(localStorage.preferredStore).address.stateOrProvince.toLowerCase().trim() :''
	let calculatedPricePerSqFt = formatMoney((price.salePrice || price.price) / pricePerSqFt)
    
	// console.log('Availability price', availability)

	function formatMoney(amount) {
		return new Intl.NumberFormat(`${lang}-CA`, { style: 'currency', currency: 'CAD'}).format(amount)
	}
	
	let clearance = availability.isOnlineClearence
	let scotiaPayModal = false

	function openScotiaPayModal() {
		scotiaPayModal = true
	}
</script>

<Portal target="#portal_price">
	<section class="pdp-price">
		<div class="ProductFlags">
			{#if dynAttr295}
				<!-- Do Nothing-->
			{:else if onlineOnlyProduct === true && price.salePrice && dotw == 'false'}
				<span class="PriceFlag">{_strings.onlineOnlySale}</span>
			{:else if clearance === true }
				<span class="ClearanceFlag">{_strings.clearanceTag}</span>
			{:else if clearance === false && price.salePrice && dotw == 'false'}
				<span class="PriceFlag">{_strings.saleTag}</span>
			{:else if dotw == 'true' && price.salePrice}
				<!--{#if lang == 'en'}
					<img src="https://homehardware.sirv.com/hh/icons/icon_DOTW.svg" alt="DOTW Icon" width="65" height="52">
				{:else}
					<img src="https://homehardware.sirv.com/hh/icons/icon_DOTW.French.svg" alt="DOTW Fr Icon" width="65" height="52">
				{/if}-->
			{/if}
			<ProductFlags displayPrice={true} dynAttr21={dynAttr21} dynAttr295={dynAttr295}></ProductFlags>
		</div>
		<aside>
			<hgroup>
				<h2>{formatMoney(price.salePrice || price.price)}</h2>
				<h3>
					<strong>
						{#if uom == 'CT'}
							/{lang == 'en' ? 'case': 'caisse'}
						{:else}
							/{uom}
						{/if}
					</strong>
					{#if price.salePrice}
						{_strings.was}&nbsp;{formatMoney(price.price)}
					{/if}
				</h3>
			</hgroup>
			{#if pricePerSqFt}
				<h4>{@html `(${calculatedPricePerSqFt}/<small>${lang == 'en' ? 'SQ. FT.': 'pi<sup>2</sup>'}</small>)`}</h4>
			{/if}
		</aside>
		{#if ehf}
			<h4>+ {formatMoney(ehf.feeAmt)} {_strings.EnviromentalhandlingFee}</h4>
		{/if}
		{#if isBuyable && (price.salePrice || price.price) >= 250 && (preferredStoreProvince != 'qc') }
			<h4 class="Small">
				{#if lang == 'en'}
					{@html `${formatMoney((price.salePrice || price.price) / 24)} / month for 24 months<sup>1</sup> with`}
					<span class="nowrap">
						<strong>Scotia SelectPay<sup class="Trademark">TM*</sup></strong>
						<img class="Icon Big" on:click={openScotiaPayModal} src="https://homehardware.sirv.com/hh/icons/icon_information.black.svg" alt="information icon" width="0" height="0" loading="lazy"> 
					</span>
					when you pay with the <strong>Scotiabank Scene+ Visa Card.</strong> <a target="_blank" class="product-locator-link" href="https://www.homehardware.ca/en/landing/scotiabank-scene-visa">Learn More</a>
				{:else}
					{@html `${formatMoney((price.salePrice || price.price) / 24)}/mois pendant 24 mois<sup>1</sup> avec `}
					<span class="nowrap">
						<strong>Paiement Sélect Scotia<sup class="Trademark">MC*</sup></strong>
						<img class="Icon Big" on:click={openScotiaPayModal} src="https://homehardware.sirv.com/hh/icons/icon_information.black.svg" alt="information icon" width="0" height="0" loading="lazy"> 
					</span>
					lorsque vous payez avec la <strong>carte Visa Scène+ Banque Scotia.</strong> <a target="_blank" class="product-locator-link" href="https://www.homehardware.ca/fr/landing/scotiabank-scene-visa">En savoir plus</a>
				{/if}
			</h4>
		{/if}

		<!-- {#if pricePerSqFt}
			{console.log(`PricePerSqFt: ${calculatedPricePerSqFt}/${lang == 'en' ? 'SQ. FT.': 'pi²'}`) }
		{/if} -->
	</section>
	<slot></slot>
</Portal>

{#if scotiaPayModal}
	<Portal target="hh-modal">
		<h3 class="Center">
			{@html lang == 'en' ? 'Scotia SelectPay<sup class="Trademark">TM</sup>' : 'Paiement Sélect<sup class="Trademark">MC</sup> Scotia'}
		</h3>
		<hr>
		<p class="h4 Center">
			{@html lang == 'en'
				? `Buy Now, Split Payments, Earn Scene+<sup class="Trademark">TM</sup> Points`
				: `Achetez maintenant, divisez les paiements, accumulez des points Scène+<sup class="Trademark">MC</sup>`
			}
		</p>
		<p class="Center">
			{@html lang == 'en'
				? `Split your purchase of $250 or more (including taxes) into monthly installment payments for up to 24 months with no interest during the plan and no installment plan fee with Scotia SelectPay<sup class="Trademark">TM</sup> on the Scotiabank® Scene+<sup class="Trademark">TM</sup> Visa<sup>*</sup> Card. Conditions apply.<br>
				After you complete your purchase and it has been posted to your account, you can choose either a 6, 12 or 24 month plan on the Scotia mobile app or Scotia online banking.`
				: `Divisez votre achat de $250 ou plus (taxes incluses) en paiements mensuels échelonnés sur une période pouvant aller jusqu'à 24 mois sans intérêt pendant la durée du plan et sans frais de plan de paiement échelonné Paiement Sélect<sup class="Trademark">MC</sup> Scotia sur la Carte Visa<sup>*</sup> Scène+<sup class="Trademark">MC</sup> Banque Scotia<sup class="Trademark">MD</sup>. Des conditions s’appliquent.<br>
				Lorsque vous avez confirmé votre achat et que ce dernier a été inscrit à votre compte, vous pouvez choisir un plan de 6, 12 ou 24 mois sur l’application mobile Scotia ou les services bancaires en ligne Scotia.`
			}
		</p>
		<div class="ButtonGroup">
			<button class="Button ButtonSecondary" on:click={()=> scotiaPayModal = false}>{lang == 'en' ? 'Close' : 'Fermer'}</button>
			<button class="Button ButtonSecondary" on:click={()=> window.open(`https://www.homehardware.ca/${lang}/landing/scotiabank-scene-visa`, '_blank')}>{lang == 'en' ? 'Learn More' : 'En savoir plus'}</button>
		</div>
		<hr>
		<small>
			{@html lang == 'en'
				? `Estimated monthly installment amount based Home Hardware’s listed price over the displayed installment plan term length. Listed price does not include applicable taxes and optional add-ons applied at check-out such as installation charges, delivery, extended warranties, Environmental Handling Fees or other charges. Monthly installment plan amount may vary and will be adjusted based on the order total amount at check-out. Other conditions apply. See Scotiabank.com/buildyourpoints for full terms and details.`
				: `Montant mensuel estimé des versements selon le prix indiqué par Home Hardware sur la durée affichée du plan de crédit à tempérament. Le prix indiqué n’inclut pas les taxes applicables et les ajouts facultatifs appliqués à la caisse, comme les frais d’installation, de livraison, les garanties prolongées, les frais de gestion environnementale ou d’autres frais. Le montant du plan de crédit à tempérament peut varier et sera ajusté en fonction du montant total de la commande à la caisse. D’autres conditions s’appliquent. Consultez le site banquescotia.com/pointsrenos pour connaître toutes les modalités et tous les détails.`
			}
		</small>
	</Portal>
{/if}







<section class="pdp-price Desktop">
	<div class="ProductFlags">
		{#if dynAttr295}
			<!-- Do Nothing-->
		{:else if onlineOnlyProduct === true && price.salePrice && dotw == 'false'}
			<span class="PriceFlag">{_strings.onlineOnlySale}</span>
		{:else if clearance === true }
			<span class="ClearanceFlag">{_strings.clearanceTag}</span>
		{:else if clearance === false && price.salePrice && dotw == 'false'}
			<span class="PriceFlag">{_strings.saleTag}</span>
		{:else if dotw == 'true' && price.salePrice}
			<!--{#if lang == 'en'}
				<img src="https://homehardware.sirv.com/hh/icons/icon_DOTW.svg" alt="DOTW Icon" width="65" height="52">
			{:else}
					<img src="https://homehardware.sirv.com/hh/icons/icon_DOTW.French.svg" alt="DOTW Fr Icon" width="65" height="52">		
			{/if} -->
		{/if}
		<ProductFlags displayPrice={true} dynAttr21={dynAttr21} dynAttr295={dynAttr295}></ProductFlags>
	</div>
	<aside>
		<hgroup>
			<h2>
				{formatMoney(price.salePrice || price.price)}
				<span class="h3">
					{#if uom == 'CT'}
						/{lang == 'en' ? 'case': 'caisse'}
					{:else}
						/{uom}
					{/if}
				</span>
			</h2>
			<h3 class="Light">
				{#if price.salePrice}
					{_strings.was}&nbsp;{formatMoney(price.price)}
				{/if}
			</h3>
		</hgroup>
		{#if pricePerSqFt}
			<h4>{@html `(${calculatedPricePerSqFt}/<small>${lang == 'en' ? 'SQ. FT.': 'pi<sup>2</sup>'}</small>)`}</h4>
		{/if}
	</aside>
	{#if ehf}
		<h4 class="h4">+ {formatMoney(ehf.feeAmt)} {_strings.EnviromentalhandlingFee}</h4>
	{/if}

	{#if isBuyable && (price.salePrice || price.price) >= 250 && (preferredStoreProvince != 'qc') }
		<h4 class="selectPay Small">
			{#if lang == 'en'}
				{@html `${formatMoney((price.salePrice || price.price) / 24)} / month for 24 months<sup>1</sup> with`}
				<span class="nowrap">
					<strong>Scotia SelectPay<sup class="Trademark">TM*</sup></strong>
					<img class="Icon Big" on:click={openScotiaPayModal} src="https://homehardware.sirv.com/hh/icons/icon-info.svg" alt="Info Icon" />
				</span>
				when you pay with the <strong>Scotiabank&reg; Scene+<sup class="Trademark">TM</sup> Visa* Card.</strong> <a target="_blank" class="product-locator-link" href="https://www.homehardware.ca/en/landing/scotiabank-scene-visa">Learn More</a>
			{:else}
				{@html `${formatMoney((price.salePrice || price.price) / 24)}/mois pendant 24 mois<sup>1</sup> avec`}
				<span class="nowrap">
					<strong>Paiement Sélect Scotia<sup class="Trademark">MC*</sup></strong>
					<img class="Icon Big" on:click={openScotiaPayModal} src="https://homehardware.sirv.com/hh/icons/icon_information.black.svg" alt="information icon" width="0" height="0" loading="lazy">
				</span>
				lorsque vous payez avec la <strong>carte Visa* Scène+<sup class="Trademark">MC</sup> Banque Scotia<sup class="Trademark">MD</sup>.</strong> <a target="_blank" class="product-locator-link" href="https://www.homehardware.ca/fr/landing/scotiabank-scene-visa">En savoir plus</a>
			{/if}
		</h4>
	{/if}


	<slot></slot>


</section>


<style>
	.pdp-price{
		margin-bottom: 1.25rem;
	}
	.pdp-price .ProductFlags {
		position: relative;
		transform: none;
	}
	.pdp-clearance-badge {
		font-family: "hhAgendaBold", sans-serif;
		padding:  0.4em 1.1em;
		font-size: .875em;
		background-color: #ffd100;
	}
	.pdp-sale-badge {
		font-family: "hhAgendaBold", sans-serif;
		color: #ffffff;
		padding: .5em 1.5em;	
		font-size: .875em;
		background-color: #D6001C;
	}

	.pdp-price > aside h3,
	.pdp-price h4 {
		font-family: "hhAgendaMedium", sans-serif;;
	}
	.pdp-price h4,
	.pdp-price .h4,
	.pdp-price .h4.Light {
		font-size: 1rem !important;
	}

	.pdp-price > aside {
		padding-top: .5em;
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
	}

	.pdp-price .product-locator-link {
		text-decoration: underline;
		font-size: 1rem;
		font-family: 'hhAgendaMedium';
		color: #54585A;
		margin-top: 0;
	}

	.pdp-price .nowrap {
		white-space: nowrap;
	}

	h4.selectPay {
		line-height: 1.3;
		font-size: 1rem;
	}
	.pdp-price>aside:has(hgroup) {
		flex-direction: column;
	}
	.pdp-price > aside > hgroup {
		display: flex;
		align-items: baseline;
		column-gap: calc(var(--gap) / 2);
		flex-wrap: wrap
	}
	.pdp-price > aside > hgroup >h2 {
		display: flex;
		align-items: baseline;
	}
	.pdp-price > aside > hgroup + h4 {
		font-family: 'hhAgendaBold', sans-serif;
	}
	

	@media (max-width: 600px) {
		.pdp-price {
			margin-top: 1.25rem;
			margin-bottom: 0px;
		}
	}
</style>

